import { Dimension, orderedDimensions, Valence } from '@upright/common/model/types';
import { Bounds, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';

export const nullBounds: Bounds = {
  height: 0,
  width: 0,
  x1: -1,
  x2: -1,
  y1: -1,
  y2: -1,
  cx: -1,
  cy: -1,
};

export function toBounds(bounds: { x1: number; x2: number; y1: number; y2: number }): Bounds {
  const { x1, x2, y1, y2 } = bounds;
  const width = Math.abs(x2 - x1);
  const height = Math.abs(y2 - y1);
  return {
    x1,
    x2,
    y1,
    y2,
    width,
    height,
    cx: x1 + width / 2,
    cy: y1 + height / 2,
  };
}

export function sideToValence(side: Side) {
  if (side === Side.LEFT) {
    return Valence.NEGATIVE;
  } else {
    return Valence.POSITIVE;
  }
}

export function getDimensionIndex(dimension: Dimension) {
  return orderedDimensions.indexOf(dimension);
}
